module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN213_1692009191.5f74f5e9.png";